import { api } from "@/comn";
import { comnUtils } from "@/comn/utils";
import { TFormSchema, TGridSchema } from "@/comn/hooks";
import { ptlEnvs } from "@/tra/tancis/ptli/comn";

/*
 * Api Token Management service
 * !== Api 토큰 관리 서비스 ==!
 */

export const BASE = {
    path: `${ptlEnvs.base}/mypage/apitknmng`,
    api: `${process.env.REACT_APP_API_PTLI}/api/v1/ptli/mypage/apitkn-mgmt`,
};

export const URLS = {
    ptli00315001q: `${BASE.path}/ptli0315001q`, // !== Api Token 목록조회 ==!
};

export const APIS = {
    getApiTknList: (data: any, page: number, size: number) => {
        return api.get(`${BASE.api}?page=${page}&size=${size}`, {
            params: comnUtils.toGetParams(data),
        });
    },

    getApiTkn: (data: any) => {
        return api.get(`${BASE.api}/dtl`, {
            params: comnUtils.toGetParams(data),
        });
    },

    saveApiTkn: (data: any) => {
        return api.post(`${BASE.api}`, {
            ...data,
        });
    },
    deleteApiTkn: (inexTpCd: any, tknNm: string) => {
        const data: any = { inexTpCd: inexTpCd, tknNm: tknNm };
        return api.put(`${BASE.api}`, {
            ...data,
        });
    },
};

export const SF_API_TKN_SRCH: TFormSchema = {
    id: "form_ApiTknSrch",
    schema: {
        inexTpCd: { type: "select", area: "comnCd", comnCd: "CGM0176", label: "L_INEX_TP" },
        tknNm: { type: "text", label: "L_TKN_NM" },
        tknCn: { type: "text", label: "L_TKN_CN" },
    },
};

export const SF_API_TKN: TFormSchema = {
    id: "form_ApiTkn",
    schema: {
        inexTpCd: { type: "select", area: "comnCd", comnCd: "CGM0176", label: "L_INEX_TP" },
        tknNm: { type: "text", label: "L_TKN_NM" },
        tknCn: { type: "text", label: "L_TKN_CN" },
    },
};

export const SG_API_TKN_LIST: TGridSchema = {
    id: "grid_ApiTkn",
    options: { pagination: "out", edit: false, index: true, radio: true },
    head: [
        { cells: [{ header: "L_TKN_NM", binding: "tknNm", width: 300 }] },
        { cells: [{ header: "L_INEX_TP", binding: "inexTpCd", width: 150 }] },
        { cells: [{ header: "L_TKN_CN", binding: "tknCn", width: "*" }] },
        { cells: [{ header: "L_FRST_REGST_ID", binding: "frstRegstId", width: 150 }] },
        { cells: [{ header: "L_FRST_RGSR_DTM", binding: "frstRgsrDtm", width: 150 }] },
        { cells: [{ header: "L_DEL_YN", binding: "delYn", width: 100 }] },
    ],
    body: [
        { cells: [{ binding: "tknNm", align: "left", edit: false }] },
        { cells: [{ binding: "inexTpCd", type: "select", area: "comnCd", comnCd: "CGM0176", edit: false }] },
        { cells: [{ binding: "tknCn", align: "left", edit: false }] },
        {
            cells: [{ binding: "frstRegstId", edit: false }],
        },
        {
            cells: [{ binding: "frstRgsrDtm", edit: false }],
        },
        {
            cells: [
                {
                    binding: "delYn",
                    type: "select",
                    edit: false,
                    options: [
                        { label: "Yes", value: "Y" },
                        { label: "No", value: "N" },
                    ],
                    viewType: "label",
                },
            ],
        },
    ],
};
